import * as React from "react";
import PropTypes from 'prop-types';
import { 
  ReferenceField,
} from 'react-admin';

const CustomField = (props: any) => {
  const { record } = props;
  // return <span>N{record['id'] + ' ' + record['name']}</span>;
  return <span>{(record['lastname']) +' '+ record['firstname']} </span>;
}
const CustomReferFieldFullName = (props: any) => {
  return (
  <>
    <ReferenceField link={false} {...props}>
      <CustomField />
    </ReferenceField>
  </>)
}
CustomReferFieldFullName.propTypes = {
  label: PropTypes.string,
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  reference: PropTypes.string,
};

export default CustomReferFieldFullName;